import React from "react";
/* import { FaBell, FaSearch, FaBars } from "react-icons/fa"; */
import { Link, NavLink } from "react-router-dom";

const DoctorHeader = ({ onMenuClick }) => {
  const appName = "Dashboard";
  return (

    <>

      <nav
        className="navbar navbar-expand-lg"
        style={{ backgroundColor: "white" }}
      >
        <div className="container">
          {/* Logo */}
          {/*   <div className="logo-wrapper">
                   <Link to="/" className="logo">
                     <h2>
                       <span
                         style={{
                           color: "black" ,
                           textShadow:
                             "none"
                            
                         }}
                       >
                         {appName}
                       </span>
                       <span>.</span>
                     </h2>
                   </Link>
                 </div> */}

          <div>

            <ul className="navbar-nav  ms-auto">

                <li className="nav-item">
                <NavLink to="/" className="nav-link">
                   <span className="notification">5</span>
                  <i className="material-icons">messages</i>
                    
                </NavLink>
              </li>

             
            </ul>
          </div>

          {/* Toggler Button */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbar"
            aria-controls="navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ background: "#dc2751" }}
          >
            <span className="navbar-toggler-icon">
              <i className="fa-regular fa-bars"></i>
            </span>
          </button>

          {/* Menu */}
          <div className="collapse navbar-collapse" id="navbar">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink to="/" className="nav-link  active">
                  Home
                </NavLink>
              </li>

              <>
                <li className="nav-item">
                  <NavLink to="/dashboard" className="nav-link">
                    Dashboard
                  </NavLink>
                </li>



                {/* Settings Dropdown */}
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Settings <i className="fa-solid fa-caret-down"></i>
                  </a>
                  <ul className="dropdown-menu">

                    <li>
                      <a
                        href="/"
                        className="dropdown-item"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="icon-user"></i> Profile
                      </a>
                    </li>

                    <li>
                      <NavLink to="/settings" className="dropdown-item">
                        <i className="icon-settings"></i> Edit Profile
                      </NavLink>
                    </li>


                  </ul>
                </li>


                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <i className="material-icons">notifications</i>
                    <span className="notification">5</span>

                  </a>
                  <ul className="dropdown-menu">
                    <li> <a className="dropdown-item" href="#">Mike John responded to your email</a> </li>
                    <li>  <a className="dropdown-item" href="#">You have 5 new tasks</a></li>
                    <li> <a className="dropdown-item" href="#">You're now friend with Andrew</a></li>

                  </ul>
                </li>
              </>

            </ul>

            {/* Optional Call Section */}
            <div style={{ display: "none" }} className="navbar-right">
              <div className="wrap">
                <div className="icon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div className="text">
                  <p>Call Us Today</p>
                  <h5>
                    <a href="tel:18001234567">800 123 4567</a>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Inline Styles if menuColor is active */}

      <style>
        {`
                 .navbar .navbar-nav .nav-link {
                   color: black !important;
                 }
               `}
      </style>



    </>


  );
};

export default DoctorHeader;
